import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import ViewMode from "@app/enum/dashboard/ViewMode";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import { TabbedDrillDownListFetcherPayload } from "@app/scene/dashboard/types/TabbedDrillDownListFetcher";
import EfficiencyMapCardConfiguration from "@app/types/dashboard/cards/efficiencyMap/EfficiencyMapCardConfiguration";
import EntityTypesSupportedInEfficiencyMap from "@app/types/dashboard/cards/efficiencyMap/EntityTypesSupportedInEfficiencyMap";
import Scope from "@app/types/dashboard/Scope";
import MapViewportState from "@app/types/map/MapViewportState";

import EfficiencyMapCardData from "./EfficiencyMapCardData";

export const fetchEfficiencyMapCardData = createAction("@dashboard/fetchEfficiencyMapCardData")<{
  callback: (data: EfficiencyMapCardData) => void;
  configuration: EfficiencyMapCardConfiguration;
  failureCallback?: () => void;
  offset?: number; // used with List view mode when we need to load more items
  scope?: Scope;
  viewMode: ViewMode;
  viewport?: MapViewportState; // used with Map view mode when user pans/zooms
}>();

export const showEfficiencyMapDrillDown = createAsyncAction(
  "@dashboard/showEfficiencyMapCardDrillDownModal/request",
  "@dashboard/showEfficiencyMapCardDrillDownModal/success",
  "@dashboard/showEfficiencyMapCardDrillDownModal/failure"
)<
  {
    configuration: EfficiencyMapCardConfiguration;
    scope: Scope;
  },
  { viewStates: Record<EntityTypesSupportedInEfficiencyMap, DrillDownViewState> },
  unknown
>();

export const hideEfficiencyMapDrillDown = createAction(
  "@dashboard/hideEfficiencyMapCardDrillDownModal"
)<void>();

export const fetchEfficiencyMapCardDrillDownData = createAsyncAction(
  "@dashboard/fetchEfficiencyMapCardDrillDownData/request",
  "@dashboard/fetchEfficiencyMapCardDrillDownData/success",
  "@dashboard/fetchEfficiencyMapCardDrillDownData/failure"
)<
  TabbedDrillDownListFetcherPayload<AnyEntity, EntityTypesSupportedInEfficiencyMap>,
  {
    entityType: EntityTypesSupportedInEfficiencyMap;
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyEfficiencyMapDrillDownListViewSettings = createAction(
  "@dashboard/applyEfficiencyMapDrillDownListViewSettings"
)<Partial<DrillDownViewState> & { entityType: EntityTypesSupportedInEfficiencyMap }>();

export const exportEfficiencyMapCardDrillDownData = createAction(
  "@dashboard/exportEfficiencyMapCardData"
)<{
  configuration: EfficiencyMapCardConfiguration;
  entityType: EntityTypesSupportedInEfficiencyMap;
  scope: Scope;
}>();

export type EfficiencyMapCardActions = ActionType<
  | typeof applyEfficiencyMapDrillDownListViewSettings
  | typeof exportEfficiencyMapCardDrillDownData
  | typeof fetchEfficiencyMapCardData
  | typeof fetchEfficiencyMapCardDrillDownData
  | typeof hideEfficiencyMapDrillDown
  | typeof showEfficiencyMapDrillDown
>;
